<template>
  <div class="component-name">
    
  </div>
</template>

<script>
import { getDashboardPage,KindOf803Series,KindOf501 } from '@/util/util.js';
export default {
  name: 'middleIndex',
  components: {
   
  },
  props: {
  
  },
  data() {
    return {
    
    }
  },
  computed: {
   
  },
  watch: {

  },
  created() {
    this.init()
   
  },
  mounted() {
    

  },
  methods: {
    init(){ 
        let dashboardPage = getDashboardPage();        
        let kind = this.$route.query.kind;
        let list803 = ['running','program','production','system','record','alarm','modification','prodspot','fix'];        
        if (KindOf803Series(kind) && list803.indexOf(dashboardPage) === -1){
          dashboardPage = 'running'
        }
        if (KindOf501(kind) && dashboardPage.indexOf('501/') === -1){
          dashboardPage = '501/running'
        }
        let urlPath = {
        path: '/' + dashboardPage,
        query: {
          mac: this.$route.query.mac,       
        }
      };


      localStorage.setItem('dashboard.lastViewMachine', this.$route.query.mac)
      this.$router.replace(urlPath)
    }
   
  }
}
</script>

<style scoped>

</style>